import Icon from 'vue-awesome/components/Icon'

Icon.register({
  link_off_outlined: {
    paths: [
      {
        d: 'M14.39 11L16 12.61V11z'
      },
      {
        d: 'M17 7h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.27-.77 2.37-1.87 2.84l1.4 1.4A4.986 4.986 0 0022 12c0-2.76-2.24-5-5-5zM2 4.27l3.11 3.11A4.991 4.991 0 002 12c0 2.76 2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1 0-1.59 1.21-2.9 2.76-3.07L8.73 11H8v2h2.73L13 15.27V17h1.73l4.01 4.01 1.41-1.41L3.41 2.86 2 4.27z'
      }
    ],
    width: '24',
    height: '24'
  }
})
